/**
 * Get the week number from a specific date
 *
 * @param {Date} date
 *
 * @returns {number}
 */
export const getWeekNumber = (date) => {
    // Copy date so don't modify original
    const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    newDate.setUTCDate(newDate.getUTCDate() + 4 - (newDate.getUTCDay() || 7));
    // Get first day of year
    const yearStart = new Date(Date.UTC(newDate.getUTCFullYear(), 0, 1));
    // Calculate full weeks to nearest Thursday
    return Math.ceil((((newDate - yearStart) / 86400000) + 1) / 7);
};
/**
 * Get all dates of a specific week for a year.
 *
 * @param {int} week
 * @param {int} year
 *
 * @returns {Array}
 */
export const getDatesOfWeek = (week, year) => {
    // If week is 53, then the first day must be in month 12
    const monthToStartFrom = week === 53 ? 11 : 0;
    const dayToCheck = new Date(year, monthToStartFrom, 1);
    let firstDayOfWeek = null;
    // Start by finding the first day of the week.
    while (true) {
        if (getWeekNumber(dayToCheck) === week && dayToCheck.getFullYear() === year) {
            firstDayOfWeek = dayToCheck;
            break;
        }
        // If the first day of the week is not within the same year as request, return an empty array.
        if (dayToCheck.getFullYear() !== year) {
            return [];
        }
        dayToCheck.setDate(dayToCheck.getDate() + 1);
    }
    const weekdays = [];
    for (let i = 0; i < 7; i++) {
        const day = new Date(firstDayOfWeek);
        day.setDate(firstDayOfWeek.getDate() + i);
        weekdays.push(day);
    }
    return weekdays;
};
/**
 * Resolves next week number and year
 *
 * @param {int} week
 * @param {int} year
 *
 * @returns {{ week: Number, year: Number }}
 */
export function getNextWeekNumberAndYear(week, year) {
    let nextWeek = week + 1;
    let updatedYear = year;
    // If no day exists in the next week, reset the week and add one year.
    if (getDatesOfWeek(nextWeek, updatedYear).length === 0) {
        nextWeek = 1;
        updatedYear += 1;
    }
    return {
        week: nextWeek,
        year: updatedYear
    };
}
/**
 * Resolves prev week number and year
 *
 * @param {int} week
 * @param {int} year
 *
 * @returns {{ week: Number, year: Number }}
 */
export function getPrevWeekNumberAndYear(week, year) {
    let previousWeek = week - 1;
    let updatedYear = year;
    if (previousWeek < 1) {
        if (getDatesOfWeek(53, updatedYear - 1).length > 0) {
            previousWeek = 53;
        }
        else {
            previousWeek = 52;
        }
        updatedYear -= 1;
    }
    return {
        week: previousWeek,
        year: updatedYear
    };
}
